import React, { useEffect, useState } from "react";
import CardImage from "../../assets/cardimg.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASEURL } from "../../utils/utils";

const Details = () => {
  const [projectDetails, setProjectDetails] = useState({});
  const [allProjects, setAllProjects] = useState([]);

  const { id } = useParams();

  const handleLoadProject = async (id) => {
    axios
      .get(BASEURL + "/project/" + id)
      .then((res) => setProjectDetails(res.data.data))
      .catch((e) => console.log(e));
  };

  const handleFetchAllProjects = async () => {
    axios
      .get(BASEURL + "/user/all/projects")
      .then((res) => setAllProjects(res.data.data.registeredProjects))
      .catch((e) => console.log(e));
  };

  const alreadyRegistered = (id) => {
    if (id && allProjects) {
      console.log(id);
      console.log(allProjects);

      const alreadyExists = allProjects.find((i) => i._id === id);
      if (alreadyExists) return true;
      return false;
    }
  };

  useEffect(() => {
    handleLoadProject(id);
    handleFetchAllProjects();
    console.log(alreadyRegistered());
  }, [id]);

  const handleRegisterToProject = () => {
    axios
      .put(BASEURL + "/user/register", {
        projectId: projectDetails._id,
      })
      .then((res) => {
        console.log(res.data);
        setAllProjects((prev) => [...prev, { _id: projectDetails._id }]);
      })
      .catch((e) => console.log(e));
  };

  return (
    <div className="m-auto">
      <div className="list-header relative flex items-center justify-center text-white h-[200px] p-14"></div>
      <div className="absolute bottom-[360px] left-[10%]">
        <img
          src={BASEURL + "/images/" + projectDetails.imageUrl}
          className="rounded-full h-[160px] object-cover w-[160px]"
          alt=""
          srcset=""
        />
      </div>
      <div className="relative px-4 md:flex justify-between mt-8 sm:px-24 py-10">
        <div className="w-full md:w-3/5 p-3">
          <div className="mb-3">
            <p className="font-bold text-2xl capitalize">
              {projectDetails?.name}
            </p>
          </div>
          <div className="flex flex-wrap">
            <div class="w-full md:max-w-xs mx-1 my-3">
              <label
                class="block text-gray-700 text-sm font-bold mb-2"
                for="endDate"
              >
                Registration Closes
              </label>
              <input
                disabled
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="endDate"
                type="text"
                value={projectDetails?.endDate?.substring(0, 10)}
                placeholder="Username"
              />
            </div>
            <div class="w-full md:max-w-xs mx-1 my-3">
              <label
                class="block text-gray-700 text-sm font-bold mb-2"
                for="mintDate"
              >
                Mint Date
              </label>
              <input
                disabled
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="mintDate"
                value={projectDetails?.mintTime?.substring(0, 10)}
                type="text"
                placeholder="Username"
              />
            </div>{" "}
            <div class="w-full md:max-w-xs mx-1 my-3">
              <label
                class="block text-gray-700 text-sm font-bold mb-2"
                for="mintPrice"
              >
                Mint Price
              </label>
              <input
                disabled
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="mintPrice"
                type="text"
                value={projectDetails?.price}
                placeholder="Username"
              />
            </div>
            <div class="w-full md:max-w-xs mx-1 my-3">
              <label
                class="block text-gray-700 text-sm font-bold mb-2"
                for="link"
              >
                Official Link
              </label>
              <input
                disabled
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="link"
                value={projectDetails?.link}
                type="text"
                placeholder="Username"
              />
            </div>
          </div>
          <br />
          <div>
            <p className="font-bold">Beat Bots Wallet Collection</p>
            <p>Allow Bot (Community, Giveaways, Team)</p>
            <br />
            <p className="underline font-bold">Welcome back to the 90s</p>
            <p className="text-[#7E7E85]">
              Beat Bots is a family-friendly social avatat brand with a
              collection of 3,333 Genesis (Gen 1) Beat Bots based on the
              Ethereum blockchain with a ERC-721A smart contract.
            </p>
            <br />
            <p className="text-[#7E7E85]">
              With a huge passion and focus for all things of the 90s, the brand
              plans to create a time capsule by building a utillty- based
              sensory and interactive exerience, to bring back and explore the
              things we used to love as kids-reignithing our memories,
              celebrating our past and bringing back our inner child.
            </p>
            <br />
            <p className="text-[#7E7E85]">
              The Beat Bot’s vision is to establish the brand further b
              develoing intellectual proerties that are positioned to champion
              the past, within the present. The vision hopes to create a place
              where people of all ages can wander and learn about our
              memorabillia from the past, through digital ownership and our
              brand’s contents and interactive eeriences
            </p>
          </div>
        </div>
        <div className="w-full md:w-[400px] px-4">
          <div className="shadow-2xl pb-4  bg-[#FAFAFB] rounded-3xl">
            <div>
              <div className="p-6">
                {alreadyRegistered(projectDetails._id) ? (
                  <p className="text-2xl  mb-3 font-semibold">
                    <i className="fa-solid fa-circle-check text-[#28A745]"></i>
                    &nbsp; Registered
                  </p>
                ) : (
                  <p className="text-2xl  mb-3 font-semibold">
                    <i className="fa-solid fa-circle-check text-[#28A745]"></i>
                    &nbsp; Register Now
                  </p>
                )}
                <p className="text-[#7E7E85] text-sm">
                  0x3604fe9421b05de0c143f
                </p>
                <p className="text-red-600 text-sm text-center mt-2">
                  <i className="text-red-400 fa-solid fa-trash-can"></i>{" "}
                  &nbsp;UnAuthorized
                </p>
              </div>

              <div className="bg-[#28A745] py-6 flex items-center justify-center flex-col text-white">
                {alreadyRegistered(projectDetails._id) ? (
                  <>
                    <i className="fa-solid fa-circle-check text-6xl"></i>
                    <p className="text-3xl mt-3">You are registered!</p>
                  </>
                ) : (
                  <button
                    onClick={handleRegisterToProject}
                    className="rounded-lg p-2 px-4 bg-white text-[#28A745] font-bold"
                  >
                    Register Now
                  </button>
                )}
              </div>

              <div className="text-center mt-4">
                <p className="text-lg text-gray-700">
                  <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;Report
                  As Scam/Fraud
                </p>
                <hr className="my-[10px]" />
                <p className="text-lg text-[color:var(--purple-color)] font-semibold">
                  {" "}
                  <i class="fa-solid fa-check"></i>&nbsp;Check Status On The
                  Verify Page
                </p>
                <hr className="my-[10px]" />
                <p className="text-lg text-[color:var(--purple-color)] font-semibold">
                  {" "}
                  <i class="fa-solid fa-calendar-check"></i>&nbsp;Add Mint Date
                  To Google Calendar
                </p>
                <hr className="my-[10px]" />
                <p className="text-lg text-[color:var(--purple-color)] font-semibold">
                  See All Registered Wallets
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <i class="fa-solid fa-shield-check"></i>
            <p className="text-xl text-center text-green-500 font-semibold">
              &nbsp; Trust & Security
            </p>
            <p className="mt-2">
              Now that you are registered, you are welcome to logout and
              disconnect your wallet. Your entry will still be saved and you can
              log back in anytime.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
